import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { CreateResumeWithLinkedInSteps } from 'builder/modules/resumeEditor'
import ModalOverlay from '../../ModalOverlay'
import { LinkedInPrefill } from './components/LinkedInPrefill'
import { useCreateResumeWithLinkedin } from './useCreateResumeWithLinkedin'
import { LinkedInError } from './components/LinkedInError'
import { LinkedInProfile } from './components/LinkedInProfile'

export const CreateResumeWithLinkedin = () => {
  const { isPhone } = useMediaQueries()
  const { currentStep, errorState } = useCreateResumeWithLinkedin()

  return (
    <ModalOverlay overlayFadeDuration={300} contentSlideDuration={300} fullScreen={isPhone}>
      {errorState ? (
        <LinkedInError />
      ) : currentStep === CreateResumeWithLinkedInSteps.linkedInURL ? (
        <LinkedInPrefill />
      ) : currentStep === CreateResumeWithLinkedInSteps.linkedInProfile ? (
        <LinkedInProfile />
      ) : null}
    </ModalOverlay>
  )
}
